namespace TotalPoll {
    import ISCEService = angular.ISCEService;
    import MediaUploadService = TotalCore.Common.Providers.MediaUploadService;
    import EmbedService = TotalCore.Common.Providers.EmbedService;
    import Component = TotalCore.Common.Component;
    import Slug = TotalCore.Common.Filters.Slug;

    @Component('components.totalpoll', {
        templateUrl: 'field-component-template',
        bindings: {
            item: '=',
            index: '=',
            onDelete: '&',
        }
    })
    class FieldComponent {
        public embed;
        public index: number;
        public item;
        public processing = false;

        constructor(private MediaUploadService: MediaUploadService, private EmbedService: EmbedService, private $sce: ISCEService) {

        }

        $onInit() {
            if (angular.isArray(this.item.validations)) {
                this.item.validations = {};
            }

            if (angular.isArray(this.item.attributes)) {
                this.item.attributes = {};
            }
        }

        generateName() {
            if (!this.item.name) {
                this.item.name = Slug.filter(this.item.label, '_');
            }
        }

        isCollapsed() {
            return this.item.collapsed;
        }

        prefix(content, separator = '-') {
            return `${this.item.uid}${separator}${content}`;
        }

        suffix(content, separator = '-') {
            return `${content}${separator}${this.item.uid}`;
        }

        toggleCollapsed() {
            this.item.collapsed = !this.item.collapsed;
        }
    }
}